var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTier4Img(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 350,
    viewBox: "0 0 304 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M147.059 2.59524C149.841 0.989299 153.268 0.9893 156.05 2.59524L298.614 84.9048C301.395 86.5107 303.109 89.4786 303.109 92.6905V257.31C303.109 260.521 301.395 263.489 298.614 265.095L156.05 347.405C153.268 349.011 149.841 349.011 147.059 347.405L4.49508 265.095C1.71352 263.489 0 260.521 0 257.31V92.6905C0 89.4786 1.71352 86.5107 4.49509 84.9048L147.059 2.59524Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M147.659 64.0835C150.068 62.6927 153.036 62.6927 155.445 64.0835L245.663 116.171C248.072 117.562 249.556 120.132 249.556 122.914V227.088C249.556 229.87 248.072 232.44 245.663 233.831L155.445 285.918C153.036 287.309 150.068 287.309 147.659 285.918L57.4408 233.831C55.0319 232.44 53.548 229.87 53.548 227.088V122.914C53.548 120.132 55.0319 117.562 57.4408 116.171L147.659 64.0835Z",
    stroke: "#C4C4C4",
    strokeWidth: 7.78578
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.341 165.663L271.341 227.488",
    stroke: "#C4C4C4",
    strokeWidth: 7.78578,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4072 122.63V153.386",
    stroke: "#C4C4C4",
    strokeWidth: 7.78578,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.949 113.928C153.35 111.404 149.759 111.404 149.159 113.928L134.464 175.834C134.402 176.097 134.297 176.347 134.153 176.576L107.228 219.376C105.872 221.531 108.279 224.074 110.505 222.839L150.36 200.731C151.103 200.319 152.006 200.319 152.748 200.731L192.603 222.839C194.829 224.074 197.236 221.531 195.881 219.376L168.956 176.576C168.812 176.347 168.707 176.097 168.644 175.834L153.949 113.928Z",
    fill: "#C4C4C4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier4Img);
export default __webpack_public_path__ + "static/media/tier-4-img.3cdb4430da8c754470818799a8be0fa5.svg";
export { ForwardRef as ReactComponent };